    import { live, ui } from '../../stores';
    import { get } from 'svelte/store';
import { isTouchDevice } from '../../ui';
    
    export function dbHover(e, p, preview, type){
        if(isTouchDevice()) return;
        //console.log('hover', preview)
        live.update(live => {
            if(!preview){
                live.previewDashboard = p;
                live.dashboardArea = type;
            }
            live.shouldHideDashboard = false;
            return live;
        })
    }

    export function dbUnhover(e, p){
        //console.log('unhovering', $ui.dashboardSelected, $live.previewDashboard)
        if(isTouchDevice()) return;
        if(!get(ui).dashboardSelected && get(live).previewDashboard == p){
            //
            live.update(live => {
                live.shouldHideDashboard = {x: e.clientX, y: e.clientY};
                return live;
            })
            //$ui.previewDashboard = null;
        }
    }

    export function dbClick(p, type){
        //console.log('clicked', type, $live.previewDashboard, $live.dashboardArea)
        if(get(ui).dashboardSelected == p && get(live).dashboardArea == type){
            ui.update(ui => {
                ui.dashboardSelected = false;
                return ui;
            })
            live.update(live => {
                live.previewDashboard = false;
                return live;
            })
            
        }else{
            ui.update(ui => {
                
                ui.dashboardSelected = p;
                console.log('selected')
                return ui;
            })
            live.update(live => {
                live.previewDashboard = p;
                live.dashboardArea = type;
                return live;
            })
        }
    }